var MobileDetect = require('mobile-detect')
var objectFitImages = require('object-fit-images')
var Cookies = require('js-cookie');
const { Like } = require('./classes/Like');
const { FamaUtils } = require('./classes/FamaUtils');
const { LazyLoad } = require('./classes/LazyLoad');


/////////////////////////
////DEBUG MODE
/////////////////////////

//FICHERO PRINCIPAL FAMA YA COMPILADO, SOLO ESTA AQUI, no se compila desde ningun sitio
$(() => {
    let futils = FamaUtils.getInstance()
    var DEBUG = {} //usa fama, famaliving


    DEBUG.ini = function () {//usa fama, famaliving
        console.log('DEBUG.ini');
        if (futils.getURLParameter("debugmode")) {

            $(() => {
                // $(“yourElements”).show();
                //CODE HERE
                $("html").addClass("debugmode");
            });
        }
    }
    DEBUG.ini();
})

//////////////////////////////////


// /**
//  *
//  * @param {string|jquery} principalSelector
//  * @param {string|jquery} thumbSelector
//  * @requires swiper.js library
//  */
// function MySwiper(principalSelector, thumbSelector) {//usa fama, famaliving
//     console.log('function MySwiper OLD PUBLIC');
//     var self = this;
//     this.principalSelector = principalSelector;
//     this.thumbSelector = thumbSelector;
//     this.principal = null;
//     this.thumb = null;
//     this.changeCallback = function (swiper) {

//         $(".thumb").removeClass("active");

//         if ($(swiper.container[0]).is("#fotos")) {
//             var $thumb = $($("#thumb").find(".thumb")[swiper.snapIndex]);

//             var scroll = (swiper.snapIndex * ($thumb.width() + 5)) - ($("#thumb").width() / 2);

//             $("#thumb").animate({scrollLeft: scroll}, 300);

//             $thumb.addClass("active");
//         }
//         else if ($(swiper.container[0]).is("#fotos-clientes")) {
//             var $thumb = $($("#thumb-clientes").find(".thumb")[swiper.snapIndex]);

//             var scroll = (swiper.snapIndex * ($thumb.width() + 5)) - ($("#thumb-clientes").width() / 2);

//             $("#thumb-clientes").animate({scrollLeft: scroll}, 300);

//             $thumb.addClass("active");
//         }
//         else if ($(swiper.container[0]).is("#videos")) {
//             var $videos = $("#videos");
//             $videos.find("iframe").each(function () {
//                 var src = $(this).attr("src");
//                 $(this).attr("src", "");
//                 $(this).attr("src", src);
//             })
//         }
//     }
//     this.params = {
//         //keyboardControl: true,
//         direction: 'horizontal',
//         paginationType: 'fraction',
//         speed: 1000,
//         nextButton: principalSelector + ' .swiper-button-next',
//         prevButton: principalSelector + ' .swiper-button-prev',
//         pagination: principalSelector + ' .swiper-pagination',
//         noSwipingClass: "controls",
//         slidesPerView: 1,
//         paginationClickable: true,
//         preloadImages: false,
//         lazyLoading: true,
//         lazyLoadingInPrevNext: true,
//         onSlideChangeStart: self.changeCallback,
//         onSlideNextStart: self.changeCallback,
//         onSlidePrevStart: self.changeCallback,
//         effect: 'fade',
//         fade: {
//             crossFade: true
//         }
//     }

//     this.reInit = function (full) {

//         if (full) {
//             this.principal.destroy();
//             this.principal = new Swiper(this.principalSelector, this.params);
//         }
//     }

//     this.principal = new Swiper(this.principalSelector, this.params);
//     this.reInit();
// }

// /**
//  *
//  * @param {string|jquery} principalSelector
//  * @param {string|jquery} thumbSelector
//  * @param {object} options
//  * @requires slick.js library
//  */


// function MySlick(principalSelector, thumbSelector, options) { //usa fama, famaliving
//     console.log('function MySlick OLD PUBLIC');
//     var self = this;
//     this.principalSelector = principalSelector;
//     this.thumbSelector = thumbSelector;
//     this.principal = null;
//     this.thumb = null;
//     this.options = options || {};
//     self.noanimate = app.device.isIPad();


//     this.params = {
//         fade: true,
//         cssEase: 'linear',
//         speed: (self.noanimate) ? 0 : 500,
//         infinite: false,
//         useCSS: true,
//         touchThreshold: 100,
//     }

//     /**
//      * Recalculate position Slider and Height.
//      */
//     this.reInit = function () {
//         //var self = this;
//         /*this.principal.slick('unslick');
// 		setTimeout(function(){
// 			self.principal.slick(self.params);
// 		}, 1000);*/
//         if (this.principal.length)
//             this.principal.slick('setPosition');

//         self.thumbLazy.checkItemsInView();
//     }

//     /**
//      * Events from component Slider
//      */
//     this.events = function () {
//         var self = this;

//         self.principal.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
//             $(self.thumbSelector + ' .thumb').removeClass('active');
//             $($(self.thumbSelector + ' .thumb')[nextSlide]).addClass('active');

//             $(self.principalSelector + ' .swiper-pagination').find(".swiper-pagination-current").text(nextSlide + 1);

//             var scroll = (nextSlide * ($(self.thumbSelector + ' .thumb').width() + 5)) - ($(self.thumbSelector).width() / 2);

//             $(self.thumbSelector).animate({scrollLeft: scroll}, 300);

//             if (typeof self.options.beforeChange == 'function')
//                 self.options.beforeChange(event, slick, currentSlide, nextSlide);
//         });

//         //Click in thumb
//         $(self.thumbSelector + ' .thumb').on('click', function (e) {
//             if ($(e.target).is(".thumb img, .thumb .icon, .thumb")) {
//                 self.principal.slick('slickGoTo', $(this).index(), self.noanimate);
//             }
//         });

//         $(principalSelector + ' .swiper-button-prev').click(function (e) {
//             e.preventDefault();
//             e.stopPropagation();
//             var current = self.principal.slick('slickCurrentSlide');
//             self.principal.slick('slickGoTo', current - 1, self.noanimate);
//         });

//         $(principalSelector + ' .swiper-button-next').click(function (e) {
//             e.preventDefault();
//             e.stopPropagation();
//             var current = self.principal.slick('slickCurrentSlide');
//             self.principal.slick('slickGoTo', current + 1, self.noanimate);
//         });
//     }


//     /**
//      * Initialize Slick
//      */
//     this.init = function () {
//         var self = this;

//         self.principal = $(self.principalSelector + " .swiper-wrapper1");
//         self.principal.slick(self.params);

//         if (self.noanimate) {
//             self.principal.slick.cssTransitions = false;
//         }

//         $($(self.thumbSelector + " .thumb")[0]).addClass('active');
//         //Controls pagination
//         $(self.principalSelector + ' .swiper-pagination').find(".swiper-pagination-total").text($(self.thumbSelector + ' .thumb').length);

//         self.events();

//         self.thumbLazy = new HorizontalLazyload(self.thumbSelector);

//         if (typeof self.options.init == 'function')
//             self.options.init();
//     }

//     // Call Initialize
//     this.init();
// }

// function HorizontalLazyload(selector) { //usa fama, famaliving
//     console.log('HorizontalLazyload OLD PUBLIC selector:', selector);
//     this.checkItemsInView = function () {
//         var self = this;
//         self.$images.filter('.horizontal-lazyload').each(function () {
//             var docViewLeft = $(self.$box).scrollLeft();
//             var docViewRight = docViewLeft + $(self.$box).width();

//             var elemLeft = $(this).offset().left;
//             var elemRight = elemLeft + $(this).width();

//             if ((elemRight <= docViewRight) && (elemLeft >= docViewLeft)) {
//                 var src = $(this).attr("data-src");
//                 $(this).attr("src", src);
//             }
//         });
//     }

//     this.events = function () {

//         var self = this;
//         self.$box.scroll(function (e) {
//             self.checkItemsInView($(this));
//             console.log("prueba");
//         });
//     }

//     this.init = function (selector) {
//         var self = this;
//         self.$box = $(selector);
//         self.$images = self.$box.find("img.horizontal-lazyload, iframe.horizontal-lazyload");
//         self.events();
//     }

//     //Initialize
//     this.init(selector);
// }

// Avoid `console` errors in browsers that lack a console.  //usa fama, famaliving
// (function () {
//     var method;
//     var noop = function () {
//     };
//     var methods = [
//         'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
//         'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
//         'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
//         'timeStamp', 'trace', 'warn'
//     ];
//     var length = methods.length;
//     var console = (window.console = window.console || {});

//     while (length--) {
//         method = methods[length];

//         // Only stub undefined methods.
//         if (!console[method]) {
//             console[method] = noop;
//         }
//     }
// }());

// // STYLE !IMPORTANT  //usa fama, famaliving
// (function ($) {
//     if ($.fn.style) {
//         return;
//     }

//     // Escape regex chars with \
//     var escape = function (text) {
//         return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
//     };

//     // For those who need them (< IE 9), add support for CSS functions
//     var isStyleFuncSupported = !!CSSStyleDeclaration.prototype.getPropertyValue;
//     if (!isStyleFuncSupported) {
//         CSSStyleDeclaration.prototype.getPropertyValue = function (a) {
//             return this.getAttribute(a);
//         };
//         CSSStyleDeclaration.prototype.setProperty = function (styleName, value, priority) {
//             this.setAttribute(styleName, value);
//             var priority = typeof priority != 'undefined' ? priority : '';
//             if (priority != '') {
//                 // Add priority manually
//                 var rule = new RegExp(escape(styleName) + '\\s*:\\s*' + escape(value) +
//                     '(\\s*;)?', 'gmi');
//                 this.cssText =
//                     this.cssText.replace(rule, styleName + ': ' + value + ' !' + priority + ';');
//             }
//         };
//         CSSStyleDeclaration.prototype.removeProperty = function (a) {
//             return this.removeAttribute(a);
//         };
//         CSSStyleDeclaration.prototype.getPropertyPriority = function (styleName) {
//             var rule = new RegExp(escape(styleName) + '\\s*:\\s*[^\\s]*\\s*!important(\\s*;)?',
//                 'gmi');
//             return rule.test(this.cssText) ? 'important' : '';
//         }
//     }

//     //NOTE: Moved to FamaUtils -> Refactor code
//     // The style function
//     $.fn.style = function (styleName, value, priority) {
//         // DOM node
//         var node = this.get(0);
//         // Ensure we have a DOM node
//         if (typeof node == 'undefined') {
//             return this;
//         }
//         // CSSStyleDeclaration
//         var style = this.get(0).style;
//         // Getter/Setter
//         if (typeof styleName != 'undefined') {
//             if (typeof value != 'undefined') {
//                 // Set style property
//                 priority = typeof priority != 'undefined' ? priority : '';
//                 style.setProperty(styleName, value, priority);
//                 return this;
//             } else {
//                 // Get style property
//                 return style.getPropertyValue(styleName);
//             }
//         } else {
//             // Get CSSStyleDeclaration
//             return style;
//         }
//     };
// })(jQuery);

/**
 * reverse
 */
//usa fama, famaliving
// $.fn.reverse = [].reverse;

// $.fn.search = function (query) {
//     return $(this).find(query).add($(this).filter(query));
// }

// Moved to FamaUtils -> Refactor code
function is(v) {
    return typeof v != "undefined" || v != null;
}

var utils = {};
// utils.support = {
//     rgba: function () {
//         var scriptElement = document.getElementsByTagName('script')[0];
//         var prevColor = scriptElement.style.color;
//         try {
//             scriptElement.style.color = 'rgba(1,5,13,0.44)';
//         } catch (e) {
//         }
//         var result = scriptElement.style.color != prevColor;
//         scriptElement.style.color = prevColor;
//         return result;
//     }
// }

//NOTE: Moved to FamaUtils -> Refactor code
// $.fn.getColor = function (x, y) {
//     var img = $(this).get(0);
//     var canvas = $("<canvas>");
//     canvas = canvas.get(0);
//     var context = canvas.getContext('2d');
//     context.drawImage(img, 0, 0);
//     data = context.getImageData(x, y, 1, 1).data;
//     if($('isFama').length < 1){
//         //delete canvas;
//     }

//     if (utils.support.rgba()) {
//         var data = "rgba(" + data[0] + ", " + data[1] + ", " + data[2] + ", " + data[3] + ")";
//     }
//     else {
//         var data = "rgb(" + data[0] + ", " + data[1] + ", " + data[2] + ")";
//     }
//     return data;
// }

//NOTE: Moved to FamaUtils -> Refactor code
/**
 * imageLoad
 */
// $.fn.imageLoad = function (fn) {
//     return $(this).each(function () {
//         if (this.complete) {
//             fn.call(this);
//             return;
//         }
//         this.onload = function () {
//             fn.call(this);
//         }
//         this.src = this.src;
//     });
// }


// function isScrolledIntoView(elem) {
//     var docViewTop = $(window).scrollTop();
//     var docViewBottom = docViewTop + $(window).height();

//     var elemTop = $(elem).offset().top;
//     var elemBottom = elemTop + $(elem).height();

//     return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
// }

//NOTE: Moved to class -> Refactor
// var LazyLoad = {
//     images: [],
//     query: function (q, res) {
//         if (document.querySelectorAll) {
//             res = document.querySelectorAll(q);
//         } else {
//             var d = document,
//                 a = d.styleSheets[0] || d.createStyleSheet();
//             a.addRule(q, 'f:b');
//             for (var l = d.all, b = 0, c = [], f = l.length; b < f; b++)
//                 l[b].currentStyle.f && c.push(l[b]);

//             a.removeRule(0);
//             res = c;
//         }
//         return res;
//     },

//     _has: function (obj, key) {
//         return Object.prototype.hasOwnProperty.call(obj, key);
//     },

//     loadImage: function (el, fn) {
//         var img = new Image(),
//             src = el.getAttribute('data-src');
//         //srcset = el.getAttribute('data-srcset');

//         img.onload = function () {
//             if (!!el.parent) {
//                 el.parent.replaceChild(img, el);
//             }
//             else {
//                 el.src = src;
//                 //el.srcset = srcset
//             }

//             $(el).removeClass('lazy');
//             $(el).removeClass('lazy-manual');

//             fn ? fn(el) : null;
//         };

//         img.src = src;
//         //img.srcset = srcset;
//     },

//     elementInViewport: function (el, calcRelativePosition) {
//         if (calcRelativePosition === true) {
//             var $this = $(el);
//             var $relativeParent = $this.closest('.lazy-relative-parent');
//             if ($relativeParent.length > 0) {
//                 return ($relativeParent.position().top + $relativeParent.height() > 0 && $relativeParent.position().top < $relativeParent.closest('.lazy-relative-id').height());
//             } else {
//                 return ($this.position().top + $this.height() > 0 && $this.position().top < $this.closest('.lazy-relative-id').height());
//             }

//         }

//         var top = el.offsetTop;
//         var left = el.offsetLeft;
//         var width = el.offsetWidth;
//         var height = el.offsetHeight;

//         while (el.offsetParent) {
//             el = el.offsetParent;
//             top += el.offsetTop;
//             left += el.offsetLeft;
//         }

//         return (
//             top >= window.pageYOffset &&
//             left >= window.pageXOffset &&
//             (top + height) <= (window.pageYOffset + window.innerHeight) &&
//             (left + width) <= (window.pageXOffset + window.innerWidth)
//         );
//     },

//     processScroll: function (calcRelativePosition, callback) {
//         for (var i = 0; i < LazyLoad.images.length; i++) {
//             if (LazyLoad.elementInViewport(LazyLoad.images[i], calcRelativePosition)) {
//                 LazyLoad.loadImage(LazyLoad.images[i], function (el) {

//                     LazyLoad.images.splice(i, i);
//                     // Array.prototype.slice.call is not callable under our lovely IE8

//                     if ($.isFunction(callback)) callback(el);

//                 });
//             }
//         }
//     },

//     init: function (calcRelativePosition, callback) {
//         LazyLoad.images = [];
//         var query = LazyLoad.query('img.lazy');
//         $("img.lazy").data("src", "");

//         for (var i = 0; i < query.length; i++) {
//             LazyLoad.images.push(query[i]);
//         }
//         ;

//         LazyLoad.processScroll(calcRelativePosition, callback);
//     }
// };

// function throttle(fn, threshhold, scope) {
//     threshhold || (threshhold = 250);
//     var last,
//         deferTimer;
//     return function () {
//         var context = scope || this;

//         var now = +new Date,
//             args = arguments;
//         if (last && now < last + threshhold) {
//             // hold on to it
//             clearTimeout(deferTimer);
//             deferTimer = setTimeout(function () {
//                 last = now;
//                 fn.apply(context, args);
//             }, threshhold);
//         } else {
//             last = now;
//             fn.apply(context, args);
//         }
//     };
// }

//NOTE: Moved to FamaUtils -> Refactor code
/**
 * Determina si un metodo o variable existe (sí está definido).
 * @param {*} func función, metodo o variable existe.
 * @param {*} type determina si es de jquery o no, si pasas "$" es jquery.
 */
// function isLoad(func, type) {
//     if (type == "$") {
//         return (typeof jQuery.fn[func] != "undefined");
//     }
//     else {
//         return (typeof window[func] != "undefined");
//     }
// }
//end usa fama, famaliving

// App
var app = app || {};

// app.Alert = function (message) {
//     if (console) {
//         console.log(message);
//     }
//     else {
//         alert(message);
//     }
// }

// app.ajaxCall = function (module, action, options) {
//     if (typeof options != "object") {
//         var options = {};
//     }
//     if (typeof options.data != "object") {
//         options.data = {};
//     }
//     if (typeof options.async == "undefined") {
//         options.async = true;
//     }
//     var language = $("html").attr("lang");

//     var resp = null;
//     $.ajax({
//         url: "/ajax.php?module=" + module + "&action=" + action + "&language=" + language,
//         data: options.data,
//         type: "post",
//         async: options.async,
//         dataType: "json",
//         beforeSend: function () {
//             if (options.beforeSend) {
//                 options.beforeSend();
//             }
//         },
//         success: function (r) {
//             if (r.status == 'ok') {
//                 if (options.target) {
//                     if (typeof options.target != "object") {
//                         options.target = $(options.target);
//                     }
//                     if (typeof options.filter != "undefined") {
//                         options.target.html($(r.html).filter(options.filter));
//                     }
//                     else {
//                         options.target.html(r.html);
//                     }
//                 }
//                 if (options.onSuccess) {
//                     resp = options.onSuccess(r);
//                 }
//                 if (r.message) {
//                     app.Alert(r.message);
//                 }
//             }
//             else if (r.status == 'redirect') {
//                 document.location.href = r.to;
//             }
//             else if (r.status == 'error') {
//                 if (r.message) {
//                     app.Alert(r.message);
//                 }
//             }
//             else {
//                 app.Alert("ERROR: UNKNOWN ERROR");
//             }
//         }
//     });
//     return resp;
// }

app.MobileDetect = new MobileDetect(window.navigator.userAgent); //usa fama, famaliving

app.device = { //usa fama, famaliving
    isMobile: function () {
        console.log('app.device isMobile OLD PUBLIC');
        var mobile = /mobile/i.test(navigator.userAgent);
        var ipad = app.device.isIPad();

        return mobile && !ipad;
    },
    isAndroid: function () {
        return /android/i.test(navigator.userAgent);
    },
    isIOS: function () {
        return /iP(hone|od|ad)/.test(navigator.platform);
    },
    isIPad: function () {
        return /iPad/.test(navigator.platform);
    },
    IOSversion: function () {
        if (!app.device.isIOS()) return false;
        var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
        return parseInt(v[1], 10);
    },
    isOldIE: function () {
        var rv = false;
        if (navigator.appName == 'Microsoft Internet Explorer') {
            var ua = navigator.userAgent;
            var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
            if (re.exec(ua) != null)
                rv = parseFloat(RegExp.$1);
            if (rv < 9) {
                rv = true;
            }
            else {
                rv = true;
            }
        }
        return rv;
    }
}

// app.Garantias = {
//     init: function () {
//         $("#contact.garantias").each(function () {
//             console.log('app.Grarantias OLD PUBLIC init()');
//             $("#contact button[type='submit']").unbind().click(function (e) {
//                 e.preventDefault();
//                 var form_ok = true;

//                 $("#contact input[type='text'], #contact select").each(function () {
//                     if ($(this).val() == "" && !$(this).is("[name='rate_product']")) {
//                         $(this).css("border-color", "red");
//                         form_ok = false;
//                     }
//                     else {
//                         $(this).css("border-color", "");
//                     }
//                 });

//                 if (form_ok) {
//                     var options = {
//                         codigo: $("#contact div.warranty-form-block input[name='codigo']").val(),
//                         nombre: $("#contact div.warranty-form-block input[name='nombre']").val(),
//                         apellidos: $("#contact div.warranty-form-block input[name='apellidos']").val(),
//                         email: $("#contact div.warranty-form-block input[name='email']").val(),
//                         localidad: $("#contact div.warranty-form-block input[name='localidad']").val(),
//                         direccion: $("#contact div.warranty-form-block input[name='direccion']").val(),
//                         codigopostal: $("#contact div.warranty-form-block input[name='codigopostal']").val(),
//                         pais: $("#contact div.warranty-form-block select[name='pais']").val(),
//                         lang: $("#contact input[name='lang']").val(),
//                         valoracion: $("#contact input[name='rate']:checked").val(),
//                         valoracion_texto: $("#contact textarea[name='rate_comment']").val(),
//                         valoracion_producto: $("#contact input[name='rate_product']").val(),
//                     }

//                     $.ajax({
//                         url: "/ajax.php?module=garantias&action=nueva&language=" + options.lang,
//                         data: options,
//                         type: "post",
//                         async: true,
//                         dataType: "json",
//                         beforeSend: function () {

//                         },
//                         success: function (r) {
//                             alert($("#i18n_garantia_validada_texto").html());
//                             $("#contact div.warranty-form-block input[name='codigo']").val("");
//                             $("#contact div.warranty-form-block input[name='nombre']").val("");
//                             $("#contact div.warranty-form-block input[name='apellidos']").val("");
//                             $("#contact div.warranty-form-block input[name='email']").val("");
//                             $("#contact div.warranty-form-block input[name='localidad']").val("");
//                             $("#contact div.warranty-form-block input[name='direccion']").val("");
//                             $("#contact div.warranty-form-block input[name='codigopostal']").val("");
//                             $("#contact input[name='rate']").prop('checked', false);
//                             $("#contact textarea[name='rate_comment']").val('');
//                             $("#contact input[name='rate_product']").val('');
//                         }
//                     });
//                 }
//             });
//         });
//     }
// }

// Esta en NewsComment Pero está en desuso. Es viejo,
// app.Noticias = {
//     init: function () {
//         // var widId = "";


//         $("#comentario_noticia").each(function () {
//             console.log('app.Noticias OLD PUBLIC comment');
//             $("#comentario_noticia button[type='submit']").unbind().click(function (e) {
//                 e.preventDefault();
//                 var form_ok = true;

//                 $("#comentario_noticia input[type='text']").each(function () {
//                     e.preventDefault();
//                     var form_ok = true;
//                     if (!$("#comentario_noticia input[type='checkbox']").is(":checked")) {
//                         $("#comentario_noticia input[type='checkbox']").parent().addClass('error');
//                         form_ok = false;
//                     }
//                     else {
//                         $("#comentario_noticia input[type='checkbox']").parent().removeClass('error');
//                     }
//                     if ($(this).val() == "") {
//                         $(this).css("border-color", "red");
//                         form_ok = false;
//                     }
//                     else {
//                         $(this).css("border-color", "");
//                     }
//                 });
//                 if (form_ok) {
//                     var form = $("#comentario_noticia").serialize();
//                     $.ajax({
//                         url: "/ajax.php?module=noticias&action=checkcaptcha",
//                         data: form,
//                         type: "post",
//                         dataType: "json",
//                         beforeSend: function () {
//                             form_ok = false;
//                         },
//                         success: function (r) {
//                             if (r.status) {
//                                 grecaptcha.reset()
//                                 app.Noticias.send();
//                             } else {
//                                 alert($("#captcha-msg").val());
//                             }
//                         }
//                     });
//                 }
//             });
//         });
//     },
//     send: function () {
//         var options = {
//             idnoticia: $("#comentario_noticia input[name='idnoticia']").val(),
//             lang: $("#comentario_noticia input[name='lang']").val(),
//             alias: $("#comentario_noticia input[name='alias']").val(),
//             email: $("#comentario_noticia input[name='email']").val(),
//             comentario: $("#comentario_noticia textarea[name='comentario']").val(),
//             siteid: $("#comentario_noticia input[name='siteid']").val()
//         }

//         $.ajax({
//             url: "/ajax.php?module=noticias&action=contact&language=" + options.lang,
//             data: options,
//             type: "post",
//             async: true,
//             dataType: "json",
//             beforeSend: function () {

//             },
//             success: function (r) {
//                 if ($(".coment-item:last").length > 0)
//                     $(".coment-item:last").after(r.commenthtml);
//                 else
//                     $(".comments").find(".row:first").prepend(r.commenthtml);

//                 alert($("input[name='comentario_publicado']").val());
//                 $("#comentario_noticia")[0].reset();
//             }
//         });
//     }
// }

/**
 * @deprecated
 */
// app.Buscador = {
//     //NO SE USA??
//     init: function () {

//         // Comienzo: buscador
//         $("#main-search-button").unbind("click").click(function (e) {

//         console.log('app.Buscador init()');
//         console.log('app.Buscador OLD PUBLIC');
//             console.log('app.Buscador');
//             e.preventDefault();
//             if ($(window).width() >= 992) {
//                 if ($("#main-search-box").hasClass("active")) {
//                     app.Buscador.mainSearchBoxHide();
//                     setTimeout(function () {
//                         $("#main-search-box").removeClass("active");
//                         $("#main-nav ul li.search a").removeClass("active");
//                     }, 390);
//                 }
//                 else {
//                     $("#main-search-box").addClass("active");
//                     $("#main-nav ul li.search a").addClass("active");
//                     app.Buscador.mainSearchBoxResize(true);
//                 }
//             }
//             else {
//                 if ($("#main-search-box").hasClass("active")) {
//                     //$("#main-search-box").removeClass("active");
//                     //setTimeout(function () {
//                     $("#main-search-box").removeClass("active");
//                     $("#main-nav ul li.search a").removeClass("active");
//                     //},390);
//                 }
//                 else {
//                     $("#main-search-box").addClass("active");
//                     $("#main-nav ul li.search a").addClass("active");
//                     $("#main-search-box input[name='main-search-input']").focus();
//                     //app.Buscador.mainSearchBoxResize(true);
//                 }
//             }
//         });
//         $("#main-search-box .search-input-frame a").unbind("click").click(function (e) {
//             e.preventDefault();
//             $("#main-search-button").click();
//         });
//         $("#main-search-box .search-input-frame input").unbind("keyup").keyup(function (e) {

//             if (e.keyCode != 38 && e.keyCode != 40 && e.keyCode != 13) { // up
//                 app.Buscador.mainSearchAction($(this).val());
//             }
//         });
//         // Fin: buscador
//     },
//     mainSearchBoxResize: function (click) {
//         var w_lc = $("#mytopbar").find("#btn-menu").width(),
//             w_lc2 = $("#mytopbar").find(".navbar-brand").width(),
//             w_mc = $("#mytopbar").find("#search-menu").width() - 15,
//             w_mn = $("#mytopbar").width() - 15,
//             w = w_mn - (w_lc + w_lc2 + 50) - w_mc;
//         $("#main-search-box").css("right", w_mc + "px");
//         if (!click && $("#main-search-box").hasClass("active")) {
//             $("#main-search-box").width(w);
//         }
//         else if (click) {
//             $("#main-search-box").animate({
//                 width: w
//             }, 400, function () {
//                 $("#main-search-box input[name='main-search-input']").focus();
//             });
//         }
//     },
//     mainSearchBoxHide: function () {
//         $("#main-search-box").animate({
//             width: 0
//         }, 400, function () {
//         });
//     },
//     mainSearchAction: function (search) {
//         $("#main-search-box .search-results .search-results-contents").html("");
//         if (search.length < 1) {
//             if ($(window).width() >= 992) {
//                 $("#main-search-box .search-results").addClass("noresults");
//                 $("#mytopbar").css("overflow", "hidden");
//                 return false;
//             }
//             else {
//                 $("#main-search-box .search-results").addClass("noresults");
//                 return false;
//             }
//         }
//         $("#main-search-box .search-results").removeClass("noresults");
//         $("#mytopbar").css("overflow", "visible");
//         var normalize = function (str) {
//             str = str_ireplace("á", "a", str);
//             str = str_ireplace("é", "e", str);
//             str = str_ireplace("í", "i", str);
//             str = str_ireplace("ó", "o", str);
//             str = str_ireplace("ú", "u", str);
//             return str;
//         }
//         var putHtml = function (html, item) {
//             html = html + '<a href="' + item.link + '">' +
//                 '<h3>' + item.nombre;
//             if ($.trim(item.subnombre) != "") {
//                 html = html + ' <span> (' + item.subnombre + ') </span> ';
//             }
//             html = html + '</h3>' +
//                 '<div>' + item.descripcion + '</div></a>';
//             return html;
//         }

//         search = normalize(search);
//         var html = '',
//             resultados = 0,
//             secciones_array = new Array(),
//             productos_array = new Array(),
//             noticias_array = new Array(),
//             blog_array = new Array(),
//             faqs_array = new Array();

//         if (typeof search_json_str == 'undefined' || search_json_str === null) {
//             return;
//         }
//         // Productos
//         if (typeof search_json_str.productos != "undefined") {
//             var f_count = search_json_str.productos.length;
//             for (f = 0; f < f_count; f++) {
//                 if (stripos(normalize(search_json_str.productos[f].nombre), search) !== false) {
//                     html = putHtml(html, search_json_str.productos[f]);
//                     productos_array.push(search_json_str.productos[f].iw4id);
//                     resultados++;
//                 }
//             }
//             for (f = 0; f < f_count; f++) {
//                 if (!in_array(search_json_str.productos[f].iw4id, productos_array)) {
//                     if (stripos(normalize(search_json_str.productos[f].descripcion), search) !== false) {
//                         html = putHtml(html, search_json_str.productos[f]);
//                         productos_array.push(search_json_str.productos[f].iw4id);
//                         resultados++;
//                     }
//                 }
//             }
//         }
//         // Secciones
//         if (typeof search_json_str.secciones != "undefined") {
//             var f_count = search_json_str.secciones.length;
//             for (f = 0; f < f_count; f++) {
//                 if (stripos(normalize(search_json_str.secciones[f].nombre), search) !== false) {
//                     html = putHtml(html, search_json_str.secciones[f]);
//                     secciones_array.push(search_json_str.secciones[f].iw4id);
//                     resultados++;
//                 }
//             }
//             for (f = 0; f < f_count; f++) {
//                 if (!in_array(search_json_str.secciones[f].iw4id, secciones_array)) {
//                     if (stripos(normalize(search_json_str.secciones[f].descripcion), search) !== false) {
//                         html = putHtml(html, search_json_str.secciones[f]);
//                         secciones_array.push(search_json_str.secciones[f].iw4id);
//                         resultados++;
//                     }
//                 }
//             }
//         }
//         // Noticias
//         if (typeof search_json_str.noticias != 'undefined') {
//             var f_count = search_json_str.noticias.length;
//             for (f = 0; f < f_count; f++) {
//                 if (stripos(normalize(search_json_str.noticias[f].nombre), search) !== false) {
//                     html = putHtml(html, search_json_str.noticias[f]);
//                     noticias_array.push(search_json_str.noticias[f].iw4id);
//                     resultados++;
//                 }
//             }
//             for (f = 0; f < f_count; f++) {
//                 if (!in_array(search_json_str.noticias[f].iw4id, productos_array)) {
//                     if (stripos(normalize(search_json_str.noticias[f].descripcion), search) !== false) {
//                         html = putHtml(html, search_json_str.noticias[f]);
//                         noticias_array.push(search_json_str.noticias[f].iw4id);
//                         resultados++;
//                     }
//                 }
//             }
//         }
//         // Blog
//         if (typeof search_json_str.blog != 'undefined') {
//             var f_count = search_json_str.blog.length;
//             for (f = 0; f < f_count; f++) {
//                 if (stripos(normalize(search_json_str.blog[f].nombre), search) !== false) {
//                     html = putHtml(html, search_json_str.blog[f]);
//                     blog_array.push(search_json_str.blog[f].iw4id);
//                     resultados++;
//                 }
//             }
//             for (f = 0; f < f_count; f++) {
//                 if (!in_array(search_json_str.blog[f].iw4id, productos_array)) {
//                     if (stripos(normalize(search_json_str.blog[f].descripcion), search) !== false) {
//                         html = putHtml(html, search_json_str.blog[f]);
//                         blog_array.push(search_json_str.blog[f].iw4id);
//                         resultados++;
//                     }
//                 }
//             }
//         }

//         // FAQs
//         if (typeof search_json_str.faqs != 'undefined') {
//             var f_count = search_json_str.faqs.length;
//             for (f = 0; f < f_count; f++) {
//                 if (stripos(normalize(search_json_str.faqs[f].nombre), search) !== false) {
//                     html = putHtml(html, search_json_str.faqs[f]);
//                     faqs_array.push(search_json_str.faqs[f].iw4id);
//                     resultados++;
//                 }
//             }
//             for (f = 0; f < f_count; f++) {
//                 if (!in_array(search_json_str.faqs[f].iw4id, productos_array)) {
//                     if (stripos(normalize(search_json_str.faqs[f].descripcion), search) !== false) {
//                         html = putHtml(html, search_json_str.faqs[f]);
//                         faqs_array.push(search_json_str.faqs[f].iw4id);
//                         resultados++;
//                     }
//                 }
//             }
//         }

//         if (resultados == 0) {
//             $("#main-search-box .search-results").addClass("noresults");
//         }
//         $("#main-search-box .search-results .search-results-contents").html(html);
//         $("#main-search-box .search-results .search-results-contents").scrollTop(0);
//     }

// }

// app.HomeBlog = {
//     init: function () {
//         $(document).find(".item-blog").each(function () {
//             console.log('app.HomeBlog OLD PUBLIC');
//             var itemBlog = $(this);
//             var carousel = $(this).find(".item-blog-pages").carousel({interval: false, wrap: false});
//             $(this).find(".next").click(function (e) {
//                 e.preventDefault();
//                 itemBlog.find(".previous").fadeIn();
//                 carousel.carousel("next");
//             });
//             $(this).find(".previous").click(function (e) {
//                 e.preventDefault();
//                 itemBlog.find(".next").fadeIn();
//                 carousel.carousel("prev");
//             })

//             carousel.on('slid.bs.carousel', function () {
//                 var items = $(itemBlog).find(".item");
//                 if (items.last().is(".active")) {
//                     $(itemBlog).find(".next").fadeOut();
//                 }
//                 else if (items.first().is(".active")) {
//                     $(itemBlog).find(".previous").fadeOut();
//                 }
//             })
//         });
//     }
// }

// app.Contest = {
//     init: function () {

//         $(document).find(".competition").each(function () {
//             console.log('app.Contest PUBLIC OLD');
//             var items = $(this).find(".block-photo");

//             items.find(".js-votar").on("click", function (e) {
//                 e.preventDefault();
//                 var $id = $(this).closest(".block-photo");
//                 var $box = $id.find(".votar-box");

//                 $(".block-photo").removeClass("in");
//                 $(".votar-box").removeClass("in");

//                 if ($box.is(".in")) {
//                     //$box.slideUp();
//                     $box.removeClass("in");
//                     $id.removeClass("in");
//                 }
//                 else {
//                     //$box.slideDown();
//                     $box.addClass("in");
//                     $id.addClass("in");
//                 }
//             });


//             items.find(".js-ampliar").on("click", function (e) {
//                 e.preventDefault();
//                 app.Gallerybox.open($(this).data("pos"));


//             });
//             items.find(".js-videos-ampliar").on("click", function (e) {
//                 e.preventDefault();
//                 app.Gallerybox.open($(this).data("pos"), $(this).data('id'));
//                 app.Gallerybox.loadVid($(this).data("item"));
//             });


//             items.find(".close-modal").on("click", function (e) {
//                 e.preventDefault();
//                 var $id = $(this).closest(".block-photo");
//                 var $photo = $id.find(".photo");
//                 if ($photo.is(".photo-modal")) {
//                     //$box.slideUp();
//                     $photo.removeClass("photo-modal");
//                 }
//                 else {
//                     //$box.slideDown();
//                     $photo.addClass("photo-modal");
//                 }
//             });
//         });

//         $("#contest").each(function () {
//             $(document).on( 'scroll' , () => {
//                 let ll = new LazyLoad()
//                 ll.init(false);
//             });

//             $(".send").on("click", function (e) {
//                 e.preventDefault(e);
//                 var $box = $(e.target).parents(".votar-box");
//                 var iw4id = $box.attr("data-iw4id"),
//                     name = $box.find('input[name="nombre"]'),
//                     email = $box.find('input[name="email"]'),
//                     competitiontype = $box.attr("data-competitiontype");
//                 var envia = true;

//                 if ($.trim(name.val()) == "") {
//                     name.css("border", "1px solid red");
//                     envia = false;
//                 }
//                 if ($.trim(email.val()) == "") {
//                     email.css("border", "1px solid red");
//                     envia = false;
//                 }

//                 if (envia) {
//                     var lang = $("#contest").attr("data-lang");
//                     options = {}
//                     $.ajax({
//                         url: "/ajax.php?module=concursos&action=vote&iw4id=" + iw4id + "&language=" + lang + "&name=" + name.val() + "&email=" + email.val() + "&competitiontype=" + competitiontype,
//                         data: options,
//                         type: "get",
//                         async: true,
//                         dataType: "json",
//                         beforeSend: function () {
//                         },
//                         success: function (r) {
//                             if (r.status == "ok") {
//                                 alert($("#i18n_concurso_gracias_por_votar").html());
//                                 //$("#contest").find(".vote_auth_main").hide();
//                                 //$("#contest div.items div.row div.item div.options a.vote").remove();
//                                 $(".js-votar").remove();
//                             }
//                             else {
//                                 alert($("#i18n_concurso_no_mas_votos").html());
//                             }
//                         }
//                     });
//                 }

//                 $box.find("input").val("");
//                 $box.toggleClass("in");

//             });
//             $(".reset").on("click", function (e) {
//                 e.preventDefault(e);
//                 var $box = $(e.target).parents(".votar-box");
//                 $box.find("input").val("");
//                 $box.toggleClass("in");
//             })
//         });
//     }
// }

app.xscroller = function (params) {
    $(document).find(".xscroller").each(function () {
        var $btnLeft, $btnRight, $wrapper, $width, $this;
        var isMousedown = false;
        var inAnimate = false;

        $this = $(this);
        $btnLeft = $this.find(".xscroller-btn-left");
        $btnRight = $this.find(".xscroller-btn-right");
        $wrapper = $this.find(".xscroller-wrapper");
        $width = $this.find(".xscroller-width");

        if ($wrapper.scrollLeft() == 0) {
            $btnLeft.hide();
        }
        //if()

        //Evento de scroll checkea que flechas deben estar visibles y cuales no.
        $($wrapper).on("scroll", function (e) {
            if ($(this).scrollLeft() <= 0) {
                $btnLeft.fadeOut();
            }
            else {
                $btnLeft.fadeIn();
            }

            if ($(this).scrollLeft() >= $width.width() - $(this).width()) {
                $btnRight.fadeOut();
            }
            else {
                $btnRight.fadeIn();
            }
            console.log($(this).scrollLeft() + " max-scroll: " + ($width.width() - $(this).width()))
        });

        //Si tiene la clase xscroller-scrolling-buttons, activamos los eventos de botones.
        if ($this.hasClass("xscroller-scrolling-buttons")) {

            var autoScroller = function (direction) {
                var step, newScroll;
                step = 100;

                if (inAnimate)
                    return;

                inAnimate = true;

                if (direction == "left") {
                    newScroll = $wrapper.scrollLeft() - 100;

                    if (newScroll < 0) {
                        newScroll = 0;
                        isMousedown = false;
                    }
                }
                else {
                    newScroll = $wrapper.scrollLeft() + 100;

                    if (newScroll > $width.width() - $wrapper.width()) {
                        newScroll = Math.ceil($width.width() - $wrapper.width());
                        isMousedown = false;
                    }
                }

                console.log("animate");

                $wrapper.animate({scrollLeft: newScroll}, function () {
                    inAnimate = false;
                    if (isMousedown) {
                        $wrapper.stop();
                        autoScroller(direction);
                    }
                });
            }

            $btnLeft.on("mousedown", function (e) {
                var scrollLeft = $wrapper.scrollLeft();
                var maxScroll = Math.ceil($width.width() - $wrapper.width());
                isMousedown = true;


                if (scrollLeft < 0) {
                    scrollLeft = 0;
                    isMousedown = false;
                }
                else if (scrollLeft > maxScroll) {
                    scrollLeft = maxScroll;
                    isMousedown = false;
                }
                else {
                    isMousedown = true;
                    autoScroller("left");
                }
            });

            $btnLeft.on("touchstart", function (e) {
                var scrollLeft = $wrapper.scrollLeft();
                var maxScroll = Math.ceil($width.width() - $wrapper.width());
                isMousedown = true;

                if (scrollLeft < 0) {
                    scrollLeft = 0;
                    isMousedown = false;
                }
                else if (scrollLeft > maxScroll) {
                    scrollLeft = maxScroll;
                    isMousedown = false;
                }
                else {
                    isMousedown = true;
                    autoScroller("left");
                }
            });

            $btnRight.on("mousedown", function (e) {
                var scrollLeft = $wrapper.scrollLeft();
                var maxScroll = Math.ceil($width.width() - $wrapper.width());

                console.log("Down");

                if (scrollLeft < 0) {
                    scrollLeft = 0;
                    isMousedown = false;
                }
                else if (scrollLeft > maxScroll) {
                    scrollLeft = maxScroll;
                    isMousedown = false;
                }
                else {
                    isMousedown = true;
                    autoScroller("right");
                }
            });

            $btnRight.on("touchstart", function (e) {
                var scrollLeft = $wrapper.scrollLeft();
                var maxScroll = Math.ceil($width.width() - $wrapper.width());

                console.log("Down");

                if (scrollLeft < 0) {
                    scrollLeft = 0;
                    isMousedown = false;
                }
                else if (scrollLeft > maxScroll) {
                    scrollLeft = maxScroll;
                    isMousedown = false;
                }
                else {
                    isMousedown = true;
                    autoScroller("right");
                }
            });

            $btnLeft.on("mouseup", function (e) {
                isMousedown = false;
            });

            $btnRight.on("mouseup", function (e) {
                isMousedown = false;
            });

            $btnLeft.on("touchend", function (e) {
                isMousedown = false;
            });

            $btnRight.on("touchend", function (e) {
                isMousedown = false;
            });
        }
    });
}


app.init = function () {
    console.log('app.init');
    if ($("body").hasClass("mobile")) app.mobileVersion = true;


    //NO SE USA?? Que es??
    /*
    if($('.product-product').length > 0){
        console.log('app.Productos.init()');
        app.Productos.init();//usa fama, famaliving
    }
    */

    // if($('.liked').length > 0 || $('.like-button').length > 0){
    //     let lk = new Like({unlike: false})
    // }

    // if($('#faqs').length > 0){ //use famaliving?
    //     console.log('app.Faq.init()');
    //     app.Faq.init();
    // }

    // if($('isFama').length < 1) {//usa famaliving
    //     console.log('app.Contact.init()');
    //     //app.Map.init();
    //     app.Contact.init();

    // }

 //TODO algo falla en js de fama, esta funcion debe de estar solo para fama, pero alli da error
    // if($('.isContest').length > 0) {//usa
    //     app.Contest.init();
    // }

    app.xscroller();//usa fama, famaliving

    // LazyLoad.init();//usa fama, famaliving

    //Compatibilidad "object-fit: cover" en IE y Edge
    objectFitImages();

    /**
     * Loader when a link is clicked
     */

    // $(document).on("click", "a", function (e) {
    //     var href = $(this).attr("href");

    //     if ($(this).attr("target") != "_blank" && typeof href != "undefined" && (href.match("^\/") || href.match(location.hostname))) {
    //         $("#page-loader").fadeIn(function () {
    //             $(this).removeClass("loader-intro");
    //             var $this = $(this);
    //             setTimeout(function () {
    //                 $this.fadeOut();
    //             }, 5000);
    //         });
    //     }

    //     if (!$(e.currentTarget).is("#menu, #menu *"))
    //         $("#menu").collapse("hide");
    // });

    // Popup de cookies OLD
    // if (Cookies.get('politica_cookies_aceptada_v2') != "1") {
    //     console.log('Coockies old public');
    //     $("#popup_cookies").addClass('mostrar');
    // }
    // $("#popup_cookies .popup_cookies_container .buttons a.aceptar").unbind("click").click(function (e) {
    //     console.log('Coockies 2 old public');
    //     e.preventDefault();
    //     Cookies.set('politica_cookies_aceptada_v2', '1', {expires: 365, path: '/'});
    //     $("#popup_cookies").fadeOut();
    // });
}

// $.urlParam = function (name) {
//     var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
//     if (results) {
//         return results[1];
//     }
//     return 0;
// }


// function str_ireplace(search, replace, subject) {//usa fama, famaliving
//     var i, k = '';
//     var searchl = 0;
//     var reg;

//     var escapeRegex = function (s) {
//         return s.replace(/([\\\^\$*+\[\]?{}.=!:(|)])/g, '\\$1');
//     };

//     search += '';
//     searchl = search.length;
//     if (Object.prototype.toString.call(replace) !== '[object Array]') {
//         replace = [replace];
//         if (Object.prototype.toString.call(search) === '[object Array]') {
//             while (searchl > replace.length) {
//                 replace[replace.length] = replace[0];
//             }
//         }
//     }

//     if (Object.prototype.toString.call(search) !== '[object Array]') {
//         search = [search];
//     }
//     while (search.length > replace.length) {
//         replace[replace.length] = '';
//     }

//     if (Object.prototype.toString.call(subject) === '[object Array]') {
//         for (k in subject) {
//             if (subject.hasOwnProperty(k)) {
//                 subject[k] = str_ireplace(search, replace, subject[k]);
//             }
//         }
//         return subject;
//     }

//     searchl = search.length;
//     for (i = 0; i < searchl; i++) {
//         reg = new RegExp(escapeRegex(search[i]), 'gi');
//         subject = subject.replace(reg, replace[i]);
//     }

//     return subject;
// }

// function in_array(needle, haystack, argStrict) {//usa fama, famaliving
//     var key = '',
//         strict = !!argStrict;
//     if (strict) {
//         for (key in haystack) {
//             if (haystack[key] === needle) {
//                 return true;
//             }
//         }
//     } else {
//         for (key in haystack) {
//             if (haystack[key] == needle) {
//                 return true;
//             }
//         }
//     }
//     return false;
// }

// function stripos(f_haystack, f_needle, f_offset) {//usa fama, famaliving
//     var haystack = (f_haystack + '').toLowerCase();
//     var needle = (f_needle + '').toLowerCase();
//     var index = 0;

//     if ((index = haystack.indexOf(needle, f_offset)) !== -1) {
//         return index;
//     }
//     return false;
// }


var FU;//usa fama, famaliving

$(document).ready(function () { //usa fama
    app.init();
    // *************** OLD?? is in old famaweb/contestsDetail.blade.php ******************

    // if ($('#fileupload').length > 0) {
    //     console.log('fileupload1');
    //     var uploadColors = $('#i18n-fileupload-colors');

    //     var extensions = $('#i18n-fileupload-size').attr('data-extensions').split(',');

    //     FU = new FileUploadMan({
    //         input: '#fileupload',
    //         btn: '#fileupload-btn',
    //         bar: '.upload-progress-bar-bg',
    //         txts: {
    //             invalidSizeExtension: $('#i18n-up_text_invalid_file_client').text(),
    //             uploading: $('#i18n-up_text_uploading').text(),
    //             uploadingWait: $('#i18n-up_text_uploading_wait').text(),
    //             uploadedOK: $('#i18n-up_text_uploadok').text(),
    //             uploadedKO: $('#i18n-up_text_uploadko').text(),
    //             uploadAtLeast: $('#i18n-up_text_first_select_a_file').text(),
    //             uploadLimitReached: $('#up_text_limit_reached').text()
    //         },
    //         s_uploadMessage: '.upload-progress-bar-txt',
    //         colors: {
    //             barBg: uploadColors.attr('data-color'),
    //             barBgKO: uploadColors.attr('data-colorko'),
    //         },
    //         extensions: extensions,
    //         maxSize: $('#i18n-fileupload-size').attr('data-max'),
    //         onUploadSuccess: function (e, data, r, ctrl) {
    //             var href = $('#fileupload').attr('data-success');
    //             document.location.href = href;
    //         },
    //         onUploadFail: function (e) {
    //             $("#wait-for-ajax-upload").hide();
    //         }
    //     });

    //     FU.initUpload_twoButtons();

    //     $('.upload-progress-bar').unbind('click').click(
    //         function (e) {
    //             e.preventDefault();
    //             e.stopPropagation();
    //             $('#fileupload').click();
    //         }
    //     );
    // }

    // var contestPS1 = $('#contestps1');
    // if (contestPS1.length > 0) {
    //     var h = contestPS1.find('.contact-form').height();
    //     h = parseFloat(h);
    //     h += 20;
    //     if (h > 0) {
    //         contestPS1.find('.ps1photo').css({height: h});
    //     }
    // }

    // if($('.shop-contact-form').length > 0){
    //     //use (fama)
    //     console.log('.shop-contact-form OLD PUBLIC');
    //     $('.shop-contact-form').on('click', function() {
    //         console.log('.shop-contact-form OLD PUBLIC');
    //         let $linkClicked = $(this);
    //         let $mapShopItem = $linkClicked.closest('article');
    //         let $mapShopName = $mapShopItem.find('.shopmap-title').html()
    //         let $contactModal = $('#shop-contact-modal');
    //         let $modalTitle = $contactModal.find('.modal-title');
    //         let $fieldShopId = $contactModal.find('input[name=shop-id]');
    //         let $fieldName = $contactModal.find('input[name=nombre]')
    //         let $fieldSurname = $contactModal.find('input[name=apellidos]')
    //         let $fieldEmail = $contactModal.find('input[name=email]');
    //         let $fieldPhone = $contactModal.find('input[name=telefono]');
    //         let $fieldMessage = $contactModal.find('textarea[name=comentario]');
    //         let $fieldConditions = $contactModal.find('input[name=condiciones]');
    //         let $sendButton = $contactModal.find('.send-button');
    //         let $cancelButton = $contactModal.find('.cancel-button');

    //         $sendButton.on('click', function() {
    //             let validation = true;

    //             if($fieldName.val().trim() === '') {
    //                 $fieldName.css('border-color', 'red');
    //                 validation = false;
    //             } else {
    //                 $fieldName.css('border-color', '');
    //             }
    //             if($fieldSurname.val().trim() === '') {
    //                 $fieldSurname.css('border-color', 'red');
    //                 validation = false;
    //             } else {
    //                 $fieldSurname.css('border-color', '');
    //             }
    //             if($fieldEmail.val().trim() === '' && $fieldPhone.val().trim() === '') {
    //                 if($fieldEmail.val().trim() === '') {
    //                     $fieldEmail.css('border-color', 'red');
    //                 } else {
    //                     $fieldEmail.css('border-color', '');
    //                 }
    //                 if($fieldPhone.val().trim() === '') {
    //                     $fieldPhone.css('border-color', 'red');
    //                 } else {
    //                     $fieldPhone.css('border-color', '');
    //                 }

    //                 validation = false;
    //             } else {
    //                 $fieldEmail.css('border-color', '');
    //                 $fieldPhone.css('border-color', '');
    //             }
    //             if($fieldMessage.val().trim() === '') {
    //                 $fieldMessage.css('border-color', 'red');
    //                 validation = false;
    //             } else {
    //                 $fieldMessage.css('border-color', '');
    //             }
    //             if($fieldConditions.prop('checked') === false) {
    //                 $fieldConditions.parent('label').addClass('error');
    //                 validation = false;
    //             } else {
    //                 $fieldConditions.parent('label').removeClass('error');
    //             }

    //             if(validation) {
    //                 let data = {
    //                     shopId: $fieldShopId.val(),
    //                     nombre: $fieldName.val(),
    //                     apellidos: $fieldSurname.val(),
    //                     email: $fieldEmail.val(),
    //                     telefono: $fieldPhone.val(),
    //                     comentario: $fieldMessage.val(),
    //                     idioma: $('html').attr('lang'),
    //                 };
    //                 $.ajax({
    //                     url: "/ajax.php?module=tiendas&action=storeContact",
    //                     data: data,
    //                     type: "post",
    //                     async: true,
    //                     dataType: "json",
    //                     beforeSend: function () {
    //                         $sendButton.prop('disabled', true);
    //                         $cancelButton.prop('disabled', true);
    //                     },
    //                     success: function (r) {
    //                         console.log(r);
    //                         if(r.status === 'ok') {
    //                             if(r.hasOwnProperty('message') && r.message !== '') {
    //                                 alert(r.message)
    //                             }
    //                             $contactModal.modal('hide');
    //                             clearShopContactFormModal();
    //                         }
    //                         if (r.status == 'error') {
    //                             if(r.hasOwnProperty('message') && r.message !== '') {
    //                                 alert(r.message)
    //                             }
    //                         }
    //                     }
    //                 });
    //             }
    //         })
    //         $cancelButton.on('click', function() {
    //             clearShopContactFormModal();
    //         })

    //         $modalTitle.html($mapShopName);
    //         $fieldShopId.val($linkClicked.data('shop-id'));
    //     });
    // }

    // if($('#shop-contact-modal').length > 0){
    //     //use ENCUENTRA TU TIENDA (fama)
    //     console.log('#shop-contact-modal OLD PUBLIC');
    //     function clearShopContactFormModal() {
    //         let $contactModal = $('#shop-contact-modal');
    //         $contactModal.find('.modal-title').html('');
    //         $contactModal.find('input[name=shop-id]').val('');
    //         $contactModal.find('input[name=nombre]').val('');
    //         $contactModal.find('input[name=apellidos]').val('');
    //         $contactModal.find('input[name=email]').val('');
    //         $contactModal.find('input[name=telefono]').val('');
    //         $contactModal.find('textarea[name=comentario]').val('');
    //         $contactModal.find('input[name=condiciones]').prop('checked', false);
    //         $contactModal.find('.send-button').prop('disabled', false);
    //         $contactModal.find('.cancel-button').prop('disabled', false);
    //     }

    // }
});

